<span
    *ngIf="!vs.isVHChild()"
    class="vs-address-grid-cell sel-vs-address"
>
    <span *ngIf="vipRuntimeList.length === 1">
        <div
            class="vs-address-grid-cell__items"
            avi-tooltip
            [showOnClick]="true"
            [tooltipControl$]="popoverControl$"
            [positionsPriority]="popoverPositions"
            (click)="openVipListPopover(vipRuntimeList[0].operStateType, $event)"
        >
            <cds-icon
                class="vs-address-grid-cell__state-icon"
                [ngClass]="getVipStateIconClass(vipRuntimeList[0].operStateType)"
                shape="{{ getIconShape(vipRuntimeList[0].operStateType) }}"
                direction="{{ getIconDirection(vipRuntimeList[0].operStateType) }}"
                size="16"
            ></cds-icon>
            {{ vipListAsString }}
            <ng-template #aviTooltipContent>
                <ng-container *ngTemplateOutlet="popOverContent"></ng-container>
            </ng-template>
        </div>
    </span>
    <span
        *ngIf="vipRuntimeList.length > 1"
        class="vs-address-grid-cell__items"
    >
        <span 
            class="vs-address-grid-cell__item"
            *ngIf="vipsWithUpState.length > 0"
        >
            <span
                class="vs-address-grid-cell__items"
                avi-tooltip
                [showOnClick]="true"
                [tooltipControl$]="popoverControl$"
                [positionsPriority]="popoverPositions"
                (click)="openVipListPopover(operStateType.OPER_UP, $event)"
            >
                <cds-icon
                    class="vs-address-grid-cell__state-icon vs-address-grid-cell__state-icon--up"
                    shape="circle-arrow"
                    size="16"
                ></cds-icon>
                {{ vipsWithUpState.length }} - {{ globalL10nKeys.addressesLabel | vtranslate }}
                <ng-template #aviTooltipContent>
                    <ng-container *ngTemplateOutlet="popOverContent"></ng-container>
                </ng-template>
            </span>
        </span>
        <span
            class="vs-address-grid-cell__item"
            *ngIf="vipsWithPendingState.length > 0"
        >
            <span
                class="vs-address-grid-cell__items"
                avi-tooltip
                [showOnClick]="true"
                [tooltipControl$]="popoverControl$"
                [positionsPriority]="popoverPositions"
                (click)="openVipListPopover(operStateType.OPER_PENDING, $event)"
            >
                <cds-icon
                    class="vs-address-grid-cell__state-icon vs-address-grid-cell__state-icon--pending"
                    shape="minus-circle"
                    size="16"
                ></cds-icon>
                {{ vipsWithPendingState.length }} - {{ globalL10nKeys.addressesLabel | vtranslate }}
                <ng-template #aviTooltipContent>
                    <ng-container *ngTemplateOutlet="popOverContent"></ng-container>
                </ng-template>
            </span>
        </span>
        <span
            class="vs-address-grid-cell__item"
            *ngIf="vipsWithDownState.length > 0"
        >
            <span
                class="vs-address-grid-cell__items"
                avi-tooltip
                [showOnClick]="true"
                [tooltipControl$]="popoverControl$"
                [positionsPriority]="popoverPositions"
                (click)="openVipListPopover(operStateType.OPER_DOWN, $event)"
            >
                <cds-icon
                    class="vs-address-grid-cell__state-icon vs-address-grid-cell__state-icon--down"
                    shape="circle-arrow"
                    direction="down"
                    size="16"
                ></cds-icon>
                {{ vipsWithDownState.length }} - {{ globalL10nKeys.addressesLabel | vtranslate }}
                <ng-template #aviTooltipContent>
                    <ng-container *ngTemplateOutlet="popOverContent"></ng-container>
                </ng-template>
            </span>
        </span>
    </span>
</span>
<span *ngIf="vs.isVHChild()">
    <span *ngFor="let vhd of vs.getConfig().vh_domain_name; let isLast = last; trackBy: trackByIndex">
      {{ vhd }}{{ isLast ? '' : ', ' }}
    </span>
</span>
<ng-template #popOverContent>
    <div class="vs-address-grid-cell__popover-caret"></div>
    <vip-list-popover
        (onClose)="closeVipListPopover()"
        [operStateType]="currentOperStateType"
        [vips]="vips"
    ></vip-list-popover>
</ng-template>
